// extracted by mini-css-extract-plugin
export var dot = "_9z-3";
export var leftContent = "_9z-1";
export var rightContent = "_9z-2";
export var timeline = "_9z-0";
export var timelineItem = "_9z-5";
export var timelineLine = "_9z-4";